<template>
    <div class="advanced-model-options">
        <div class="advanced-model-options__input">
            <label>Image size</label>
            <Select :model-value="localInputs.size" @onChange="onUpdateImageSize">
                <Option v-for="size in sizeOptions" :key="size" :value="size">
                    {{ size }}
                </Option>
            </Select>
        </div>

        <Space>
            <Button type="primary" @click="onSaveUpdates">Save</Button>
        </Space>
    </div>
</template>

<script lang="ts">
const sizeOptions = ["1024x1024", "1792x1024", "1024x1792"] as const;

export type CustomInputs = {
    size: (typeof sizeOptions)[number];
};

export const defaultCustomInputs: CustomInputs = {
    size: "1024x1024"
};

export default {
    props: {
        customInputs: {
            type: Object as () => CustomInputs,
            required: true
        }
    },

    emits: ["updatedCustomInputs"],

    data() {
        return {
            sizeOptions,
            localInputs: { ...this.customInputs }
        };
    },

    methods: {
        onUpdateImageSize(val: CustomInputs["size"]) {
            this.localInputs.size = val;
        },

        onSaveUpdates() {
            this.$emit("updatedCustomInputs", { ...this.localInputs });
        }
    }
};
</script>
